export default __webpack_public_path__ + "static/media/spark_65.a533cb06.png";